import type { AsyncValuesCallback, FileTypes } from "shelving";
import { call, isArrayLength } from "shelving";
import { MEDIA_TYPES } from "../../util/media.js";

/**
 * Hidden input that selects a file (via the platform specific file picker) on click.
 * - Maximum number of files can be set via `max` prop (if not set will be set to one).
 * - File MIME types can be set via `types` prop.
 * - Calls the `action()` callback when files are picked (will filter the list to `max` and will error if any picked files don't match `files`).
 * - To click on the file wrap it in a `<label>` that has an appropriate custom appearance.
 */
export function FileInput({
	disabled = false,
	multiple = false, //
	types = MEDIA_TYPES,
	capture,
	onFiles,
}: {
	disabled?: boolean;
	hidden?: boolean;
	multiple?: boolean;
	types?: FileTypes | undefined;
	capture?: "user" | "environment" | undefined;
	onFiles: AsyncValuesCallback<readonly [File, ...File[]]>;
}): React.ReactElement {
	return (
		<input
			name="file"
			type="file"
			accept={Object.values(types).join(",")}
			capture={capture}
			multiple={multiple}
			onClick={e => {
				if (disabled) e.preventDefault();
			}}
			onChange={({ currentTarget: { files } }) => {
				if (!disabled && files) {
					const arr = [...files];
					if (isArrayLength(arr)) call(onFiles, ...arr);
				}
			}}
			disabled={disabled}
			className="hidden"
		/>
	);
}
